import { createContext, useContext, useState, type PropsWithChildren } from 'react';

type FormStatusContextType = {
  isDirty: boolean;
  setIsDirty: (val: boolean) => void;
}

export const FormStatusContext = createContext<FormStatusContextType>({
  isDirty: false,
  setIsDirty: ()=> {},
});

export const useUnsavedChanges = () => {
  const context = useContext(FormStatusContext);
  if (!context) {
    throw new Error('useUnsavedChanges must be used within an FormStatusContext');
  }
  return context;
};

export function FormStatusProvider({ children }: PropsWithChildren) {
  const [isDirty, setIsDirty] = useState(false);

  return (
    <FormStatusContext.Provider value={{ isDirty, setIsDirty }}>
      {children}
    </FormStatusContext.Provider>
  );
}